import { gql } from '@apollo/client';

export const UPDATE_JOB_AUDIT_SITE_DATA = gql`
  mutation UpdateJobAuditSiteData($jobId: Int!, $data: JobAuditSiteDataUpdateInput!) {
    UpdateJobAuditSiteData(jobId: $jobId, data: $data) {
      success
    }
  }
`;

export const CREATE_JOB_AUDIT_SITE_DATA = gql`
  mutation CreateJobAuditSiteData($jobId: Int!, $data: JobAuditSiteDataCreateInput!) {
    CreateJobAuditSiteData(jobId: $jobId, data: $data) {
      photoRecords {
        id
      }
    }
  }
`;

export const DELETE_JOB_MOBILE_PHOTO_RECORDS = gql`
  mutation DeletePhotoRecords($jobId: Int!, $photoAttachmentIds: [Int!]!, $deletePrimary: Boolean) {
    DeletePhotoRecords(jobId: $jobId, photoAttachmentIds: $photoAttachmentIds, deletePrimary: $deletePrimary) {
      success
      message
    }
  }
`
